import Axios from "axios";
import { ApiResultModel } from "../models/common.model";
import {
  AddSupplierToLoanTemplateRequest,
  CloneTheLoanTemplateResponse,
  GetAllLoanTemplatesResponse,
  GetFinancialSuppliersResponse,
  GetLoanTemplateDetailByIdResponse,
  GetLoanTemplateInfoResponse,
  GetLoanTemplateSummaryResponse,
  LoanPlanIdRequest,
  LoanTemplateIdRequest,
  LoanTemplateSpecification,
} from "../models/loanTemplate.model";
import { ApiBaseUrl, LoanTemplateUrl } from "../config/config";

export const getFinancialSuppliers = (): Promise<GetFinancialSuppliersResponse[]> => {
  return Axios.post<ApiResultModel<GetFinancialSuppliersResponse[]>>(
    ApiBaseUrl + LoanTemplateUrl + "/GetFinancialSuppliers"
  ).then((result) => {
    return result.data.data;
  });
};

export const getLoanTemplateSummary = (
  data: LoanTemplateIdRequest
): Promise<GetLoanTemplateSummaryResponse[]> => {
  return Axios.post<ApiResultModel<GetLoanTemplateSummaryResponse[]>>(
    ApiBaseUrl + LoanTemplateUrl + "/GetLoanTemplateSummary",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const getLoanTemplateInfo = (
  data: LoanTemplateIdRequest
): Promise<GetLoanTemplateInfoResponse> => {
  return Axios.post<ApiResultModel<GetLoanTemplateInfoResponse>>(
    ApiBaseUrl + LoanTemplateUrl + "/GetLoanTemplateInfo",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const getLoanTemplateCloneInfo = (
  data: LoanTemplateIdRequest
): Promise<LoanTemplateSpecification> => {
  return Axios.post<ApiResultModel<LoanTemplateSpecification>>(
    ApiBaseUrl + LoanTemplateUrl + "/GetLoanTemplateCloneInfo",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const cloneTheLoanTemplate = (
  data: LoanTemplateSpecification
): Promise<CloneTheLoanTemplateResponse> => {
  return Axios.post<ApiResultModel<CloneTheLoanTemplateResponse>>(
    ApiBaseUrl + LoanTemplateUrl + "/CloneTheLoanTemplate",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const addSupplierToLoanTemplate = (
  data: AddSupplierToLoanTemplateRequest
): Promise<boolean> => {
  return Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + LoanTemplateUrl + "/AddSupplierToLoanTemplate",
    data
  ).then((result) => {
    return result.data.data;
  });
};

// add servises for loanpalns

export const GetAllLoanTemplates = (): Promise<GetAllLoanTemplatesResponse[]> => {
  return Axios.get<ApiResultModel<GetAllLoanTemplatesResponse[]>>(
    ApiBaseUrl + LoanTemplateUrl + "/GetAllLoanTemplates/"
  ).then((result) => {
    return result.data.data;
  });
};
export const GetLoanTemplateDetailById = (
  data: LoanPlanIdRequest
): Promise<GetLoanTemplateDetailByIdResponse> => {
  return Axios.get<ApiResultModel<GetLoanTemplateDetailByIdResponse>>(
    ApiBaseUrl +
      LoanTemplateUrl +
      "/GetLoanTemplateDetailById/" +
      data.loanTemplateId +
      "/"
  ).then((result) => {
    return result.data.data;
  });
};
